<template>
  <div>
    <el-dialog
      :title="$t('dialog.payment')"
      :visible.sync="paymentDialog"
      :close-on-click-modal="false"
      width="900px"
    >
      <!-- <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row align-end">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày</div>
                <SingleCalendar />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Đến ngày</div>
                <div class="child-w-80">
                  <SingleCalendar />
                </div>
              </div>
            </div>
            <das-button color="primary" size="small" append-icon="search" />
          </div>
        </div>
      </div> -->
      <div class="das-info-title mt-0">Thông tin tài khoản</div>
      <InfoList :columns="1">
        <InfoListLabel>Tài khoản công nợ</InfoListLabel>
        <InfoListValue>{{ mainSelectedRow.name || 'Unknown' }}</InfoListValue>

        <InfoListLabel>Tổng số dư hóa đơn</InfoListLabel>
        <InfoListValue
          >{{
            this.$displayCurrency(paymentRowInfo?.invoice || 0)
          }}
          VND</InfoListValue
        >

        <InfoListLabel>Số dư thanh toán</InfoListLabel>
        <InfoListValue
          >{{
            this.$displayCurrency(paymentRowInfo?.payment || 0)
          }}
          VND</InfoListValue
        >

        <InfoListLabel>Số dư tài khoản</InfoListLabel>
        <InfoListValue
          >{{
            this.$displayCurrency(paymentRowInfo?.surplus || 0)
          }}
          VND</InfoListValue
        >
        <!-- <template v-for="item in paymentDialogInfo">
          <template>
            <InfoListLabel :key="item.label">{{ item.label }}</InfoListLabel>
            <InfoListValue :key="item.value" style="width: 100px">{{
              Number(item.value).toLocaleString('en') || null
            }}</InfoListValue>
          </template>
        </template> -->
      </InfoList>
      <div v-loading="loading" style="height: 300px">
        <GridVx
          ref="agGrid"
          :columns="paymentCols"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          dom-layout="scroll"
          :rows="paymentRows"
          class="agGrid"
          @selectionChanged="paymentSelectionChanged"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="paymentDialog = false"
          >
            {{ $t('button.close') }}
          </button>
          <button
            :disabled="
              paymentRowSelecteds.length == 0 ||
              paymentRowSelecteds[0]?.gl_original !== 0
            "
            class="btn primary small outline"
            @click="deleteDebtInvoicePayment"
          >
            {{ $t('button.delete') }}
          </button>
          <button
            :disabled="paymentRowSelecteds.length == 0"
            class="btn primary small"
            @click="onApplyPayment"
          >
            {{ $t('button.apply') }}
          </button>
          <button
            :disabled="
              paymentRowSelecteds.length == 0 ||
              paymentRowSelecteds[0]?.gl_original === 0
            "
            class="btn primary small"
            @click="onUnApplyPayment"
          >
            {{ $t('button.unApply') }}
          </button>
          <button class="btn primary small" @click="onAddPayment">
            {{ $t('button.add') }}
          </button>
          <!-- <button disabled class="btn primary small">
            {{ $t('button.downloadExcel') }}
          </button> -->
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Tiến hành thanh toán"
      :visible.sync="applyPaymentDialog"
      :close-on-click-modal="false"
      width="1000px"
      @close="closeApplyPaymentDialog"
    >
      <div class="das-form-container">
        <div class="das-info-title">Thông tin tài khoản</div>
        <InfoList :columns="1">
          <InfoListLabel>Tài khoản công nợ</InfoListLabel>
          <InfoListValue>{{ mainSelectedRow.name || 'Unknown' }}</InfoListValue>

          <InfoListLabel>Số dư của phiếu thanh toán</InfoListLabel>
          <InfoListValue
            >{{
              this.$displayCurrency(surplusInvoicePayment)
            }}
            VND</InfoListValue
          >

          <InfoListLabel>Mã phiếu thanh toán</InfoListLabel>
          <InfoListValue>{{
            paymentRowSelecteds[0]?.inv_pay_num
          }}</InfoListValue>
          <InfoListLabel>Mô tả</InfoListLabel>
          <InfoListValue>{{ paymentRowSelecteds[0]?.note }}</InfoListValue>
        </InfoList>
      </div>
      <div v-loading="loading" style="height: 300px">
        <GridVx
          ref="invoicePaymentGrid"
          :columns="invoicePaymentCols"
          :context="context"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          :row-multi-select-with-click="true"
          dom-layout="scroll"
          :rows="invoicePaymentRows"
          class="agGrid"
          @selectionChanged="invoicePaymentSelectionChanged"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="applyPaymentDialog = false"
          >
            Đóng
          </button>
          <!-- <button class="btn primary small" @click="onAddPayment">
            Một phần
          </button>
          <button class="btn primary small">Tổng</button> -->
          <button
            class="btn primary small"
            :disabled="invoicePaymentSelectedRows.length == 0"
            @click="submitApplyInvoicePayment"
          >
            Áp dụng
          </button>
          <!-- <button class="btn primary small" disabled>Xuất Excel</button> -->
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Thêm thanh toán cho tài khoản công nợ"
      :visible.sync="addPaymentDialog"
      :close-on-click-modal="false"
      width="700px"
      @close="closeAddPaymentDialog"
    >
      <validation-observer ref="paymentFormValidatorAdd">
        <el-tabs
          v-model="tabIndex"
          tab-position="left"
          style="height: 400px"
          @tab-click="onTabClick"
        >
          <el-tab-pane
            v-for="(item, index) in paymentMethods"
            :key="index"
            :label="item.name"
          >
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-6">
                    <validation-provider
                      rules="required"
                      name="Ngày thanh toán"
                    >
                      <div class="das-form-input">
                        <div class="label required">Ngày thanh toán</div>
                        <CalendarSelect
                          v-model="addPaymentForm.pay_date"
                          style="display: block; width: 100%"
                          mode="date"
                        />
                        <!-- <SingleCalendar v-model="addPaymentForm.pay_date" /> -->
                      </div>
                    </validation-provider>
                  </div>
                  <div class="das-form-col col-6">
                    <div class="das-form-input">
                      <div class="label required">
                        <span>Số tiền</span>
                      </div>
                      <div
                        style="display: flex; align-items: center; gap: 10px"
                      >
                        <validation-provider
                          style="flex: 2"
                          rules="required"
                          name="Số tiền"
                        >
                          <VxCurrencyInput v-model="addPaymentForm.money" />
                        </validation-provider>
                        <el-select
                          v-model="testValue"
                          style="flex: 1"
                          placeholder=""
                        >
                          <el-option :key="9999" :value="null" label="VND" />
                          <!-- <el-option
                      v-for="item in subTransactionList"
                      :key="item.id"
                      :label="item.description"
                      :value="item.id"
                    >
                    </el-option> -->
                        </el-select>
                        <!-- <select style="flex: 1">
                        <option>VND</option>
                      </select> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-6">
                    <validation-provider rules="required" name="Loại">
                      <div class="das-form-input">
                        <div class="label required">
                          <span class="required">Loại</span>
                        </div>
                        <!-- <select>
                      <option>Demo 1</option>
                      <option>Demo 2</option>
                    </select> -->
                        <el-select
                          v-model="addPaymentForm.sub_transaction_id"
                          placeholder=""
                        >
                          <el-option label="Chọn" :value="null" />
                          <el-option
                            v-for="option in paymentOptions"
                            :key="option.c_sub_transaction_id"
                            :label="option.c_sub_transaction_nm"
                            :value="option.c_sub_transaction_id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </validation-provider>
                  </div>
                  <!-- <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Tài khoản công nợ</span>
                    </div>
                    <input type="text" />
                  </div>
                </div> -->
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">Ghi chú</div>
                      <textarea v-model="addPaymentForm.note" :rows="3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </validation-observer>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addPaymentDialog = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="addNewDebtPayment">
            {{ $t('button.add') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getTransactionConfig } from '@/api/cashier_service/postTransaction'
import {
  getInvoiceByPaymentApi,
  getPaymentRowsApi,
  // eslint-disable-next-line no-unused-vars
  applyDebtInvoiceApi,
  // eslint-disable-next-line no-unused-vars
  unApplyDebtInvoiceApi,
  // eslint-disable-next-line no-unused-vars
  addNewDebtPaymentApi,
  deleteDebtInvoicePaymentApi
} from '@/api/accounting/ar-account'
// eslint-disable-next-line no-unused-vars
import { CellRenderCurrencyInput } from '@/utils/cellRenders.js'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput
  },
  props: {
    debtAccountId: {
      type: Number,
      default: -1
    },
    mainSelectedRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabIndex: '0',
      paymentRowInfo: {
        invoice: null,
        payment: null,
        surplus: null
      },
      paymentTransactionConfig: [],
      paymentOptions: [],
      addPaymentForm: {
        money: null,
        note: null,
        pay_date: null,
        debt_account_id: null,
        currency_id: 5,
        sub_transaction_id: null
      },
      context: null,
      testValue: null,
      paymentMethods: [
        {
          name: 'Tiền mặt'
        },
        {
          name: 'Chuyển khoản'
        }
      ],
      loading: false,
      applyPaymentDialog: false,
      addPaymentDialog: false,
      paymentDialog: false,
      paymentCols: [
        {
          headerName: 'GL Period',
          field: 'gl_period'
        },
        {
          headerName: 'Inv Pay Num',
          field: 'inv_pay_num'
        },
        {
          headerName: 'Mô tả',
          field: 'note'
        },
        // {
        //   headerName: 'Trang giao dịch',
        //   field: 'code'
        // },
        {
          headerName: 'Tổng',
          field: 'original_total',
          valueGetter: param => {
            if (param.data.original_total) {
              return this.$displayCurrency(param.data.original_total)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Chưa áp dụng',
          field: 'money',
          valueGetter: param => {
            if (param.data.money) {
              return this.$displayCurrency(param.data.money)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Ngày tạo',
          field: 'create_date',
          valueGetter: param => {
            if (param.data.create_date) {
              return this.$displayDate(param.data.create_date)
            } else {
              return null
            }
          }
        },
        // {
        //   headerName: 'Đã trả trước',
        //   field: 'code'
        // },
        {
          headerName: 'Đã áp dụng',
          field: 'gl_original',
          valueGetter: param => {
            if (param.data.gl_original) {
              return this.$displayCurrency(param.data.gl_original)
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
        // {
        //   headerName: 'Loại',
        //   field: 'code'
        // }
      ],
      paymentRows: [],
      paymentRowSelecteds: [],
      invoicePaymentCols: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Số HĐ',
          field: 'invoice_number_sequence',
          maxWidth: 120
        },
        {
          headerName: 'Mô tả',
          field: 'description'
        },
        {
          headerName: 'Trang GD',
          field: 'trans_page',
          maxWidth: 90
        },
        {
          headerName: 'Số tiền gốc',
          field: 'original_total',
          // cellClass: 'ag-cell-right',
          valueGetter: param => {
            if (param?.data?.original_total) {
              return this.$displayCurrency(param.data.original_total)
            } else {
              return null
            }
          },
          maxWidth: 120
        },
        {
          headerName: 'Số dư',
          field: 'surplus',
          valueGetter: param => {
            if (param?.data?.surplus) {
              return this.$displayCurrency(param.data.surplus)
            } else {
              return null
            }
          },
          maxWidth: 120
        },
        {
          headerName: 'Số tiền đã được áp dụng',
          field: 'appliedAmount',
          valueGetter: param => {
            if (param?.data?.appliedAmount) {
              return this.$displayCurrency(param.data.appliedAmount)
            } else {
              return null
            }
          },
          maxWidth: 200
        },
        // {
        //   headerName: 'GL Origin',
        //   field: 'gl_original',
        //   valueGetter: param => {
        //     if (param?.data?.gl_original) {
        //       return this.$displayCurrency(param.data.gl_original)
        //     } else {
        //       return null
        //     }
        //   },
        //   maxWidth: 120
        // },
        {
          headerName: 'GL Applied',
          field: 'gl_applied',
          cellRenderer: 'CellRenderCurrencyInput'
        }
      ],
      invoicePaymentRows: [],
      invoicePaymentSelectedRows: []
    }
  },
  computed: {
    surplusInvoicePayment() {
      const initSurplusPayment = this.paymentRowSelecteds[0]?.money || 0
      const appliedInvoiceAmmount = this.invoicePaymentRows.reduce(
        (a, b) => a + b.appliedAmount,
        0
      )
      return initSurplusPayment - appliedInvoiceAmmount
    }
  },
  watch: {
    applyPaymentDialog() {
      this.applyPaymentDialog ? null : this.resetApplyPaymentDialog()
    },
    paymentDialog() {
      this.paymentDialog ? null : this.resetPaymentDialog()
    },
    mainSelectedRow() {}
  },
  beforeMount() {
    this.context = { componentParent: this }
    // this.getTransactionConfigList()
  },
  methods: {
    async deleteDebtInvoicePayment() {
      const id = this.paymentRowSelecteds[0]?.id || null
      await deleteDebtInvoicePaymentApi(id)
        .then(async res => {
          const message = res.message
          await this.getPaymentRows()
          this.addPaymentDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    closeAddPaymentDialog() {
      this.tabIndex = '0'
      this.$nullValueInObj(this.addPaymentForm)
    },
    closeApplyPaymentDialog() {
      this.addPaymentForm = {
        money: null,
        note: null,
        pay_date: null,
        debt_account_id: null,
        currency_id: 5,
        sub_transaction_id: null
      }
      this.invoicePaymentRows = []
    },
    async addNewDebtPayment() {
      if (
        (await this.$vxForm.isValid(this.$refs.paymentFormValidatorAdd)) ===
        false
      ) {
        return
      }
      this.addPaymentForm.debt_account_id = this.mainSelectedRow.id
      await addNewDebtPaymentApi(this.addPaymentForm)
        .then(async res => {
          const message = res.message
          await this.getPaymentRows()
          this.addPaymentDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getTransactionConfigList() {
      const params = {
        type: 1,
        area: 3
      }
      const paymentData = await getTransactionConfig(params)
      this.paymentTransactionConfig = paymentData?.data || []
      this.paymentOptions = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'CASH_DEBT_PAYMENT'
        // "TRANSFER_DEBT_PAYMENT"
      )
    },
    async submitApplyInvoicePayment() {
      // eslint-disable-next-line no-unused-vars
      const params = {
        paymentId: this.paymentRows[0]?.id || null
      }
      // Validate
      if (this.surplusInvoicePayment < 0) {
        this.$message({
          message: 'GL Applied đã nhập lớn hơn số dư của phiếu thanh toán',
          type: 'error'
        })
        return
      }
      const defectRows = this.invoicePaymentSelectedRows.filter(
        item => item.surplus < 0
      )
      if (defectRows.length > 0) {
        this.$message({
          message: 'GL Applied đã nhập lớn hơn số tiền gốc',
          type: 'error'
        })
        return
      }
      //
      // eslint-disable-next-line no-unused-vars
      const data = this.invoicePaymentSelectedRows.map(item => {
        return {
          invoiceId: item.id,
          money: item.gl_applied || 0
        }
      })
      await applyDebtInvoiceApi(params, data)
        .then(async res => {
          const message = res.message
          await this.getPaymentRows()
          this.applyPaymentDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onTabClick() {
      this.$nullValueInObj(this.addPaymentForm)
      if (this.tabIndex === '0') {
        this.paymentOptions = this.paymentTransactionConfig.filter(
          item => item.method_nm === 'CASH_DEBT_PAYMENT'
          // "CASH_DEBT_PAYMENT"
        )
      } else if (this.tabIndex === '1') {
        this.paymentOptions = this.paymentTransactionConfig.filter(
          item => item.method_nm === 'TRANSFER_DEBT_PAYMENT'
          // "TRANSFER_DEBT_PAYMENT"
        )
      }
    },
    changeCurrencyInput(params, value) {
      const agGrid = this.$refs.invoicePaymentGrid.gridApi
      if (isNaN(value)) {
        return
      }
      // if (value > params.data.surplus) {
      //   this.$message({
      //     message: 'GL Applied đã nhập không hợp lệ',
      //     type: 'error'
      //   })
      //   agGrid.forEachNode(node => {
      //     if (node.rowIndex === params.rowIndex) {
      //       node.setDataValue('gl_applied', 0)
      //     }
      //   })
      //   return
      // }
      // invoicePaymentGrid
      const index = params.rowIndex
      // Tong so tien duoc ap dung
      const totalAppliedAmmount =
        value + this.invoicePaymentRows[index]['appliedAmountInit']
      this.invoicePaymentRows[index]['appliedAmount'] = totalAppliedAmmount
      // So du con lai cua hoa don
      const caculatedSurplus =
        this.invoicePaymentRows[index]['surPlusInit'] - value
      this.invoicePaymentRows[index]['surplus'] = caculatedSurplus
      agGrid.forEachNode(node => {
        if (node.rowIndex === params.rowIndex) {
          node.setDataValue('surplus', caculatedSurplus)
          node.setDataValue('appliedAmount', totalAppliedAmmount)
          node.setDataValue('gl_applied', value)
        }
      })
    },
    resetPaymentDialog() {
      this.paymentRows = []
      this.paymentRowSelecteds = []
    },
    resetApplyPaymentDialog() {
      this.invoicePaymentSelectedRows = []
      this.invoicePaymentRows = []
    },
    invoicePaymentSelectionChanged(rows) {
      this.invoicePaymentSelectedRows = rows
    },
    paymentSelectionChanged(row) {
      this.paymentRowSelecteds = row
    },
    async onAddPayment() {
      await this.getTransactionConfigList()
      this.addPaymentDialog = true
    },
    async onApplyPayment() {
      const params = {
        debtAccountId: this.debtAccountId
      }
      const data = await getInvoiceByPaymentApi(params)
      this.invoicePaymentRows = data.data.map(item => {
        return {
          ...item,
          surPlusInit: item.surplus,
          appliedAmountInit: item.appliedAmount,
          gl_applied: 0
        }
      })
      this.applyPaymentDialog = true
    },
    async onUnApplyPayment() {
      const id = this.paymentRowSelecteds[0].id || null
      await unApplyDebtInvoiceApi(id)
        .then(async res => {
          const message = res.message
          await this.getPaymentRows()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getPaymentRows() {
      const params = {
        debtAccountId: this.debtAccountId
      }
      const data = await getPaymentRowsApi(params)
      this.paymentRows = data.data.result || []
      this.paymentRowInfo = data.data.extend || {}
      this.paymentRowSelecteds = []
      console.log('paymentRows', this.paymentRows)
    }
  }
}
</script>
